import styled from 'styled-components';

export const Page = styled.div`
  padding: 0 3rem;
`;
